





























































































































































import { Component } from "vue-property-decorator";
import { Route } from "vue-router";
import Dialog from "@/components/Dialog.vue";
import axios from "axios";
import router from "../router";
import HacoCommonWithBase from "../HacoCommonWithBase";
import LoginComp from "@/components/LoginComp.vue";
@Component({
  components: {
    LoginComp,
    Dialog
  }
})
export default class HacoAuth extends HacoCommonWithBase {
  $debugServer!: string;
  $certification!: boolean;
  currentPage: string | undefined = "";
  selectedLanguage = "en";

  mounted(): void {
    console.log("[mounted]");

    router.beforeEach((to: Route, from: Route, next: Function) => {
      if (to.params.saveAndBack === "1") {
        next();
      } else {
        const pages: string[] = this.getEditablePageList();
        const currentPage: string | undefined = from.name;
        let bool = false;
        for (const page of pages) {
          if (currentPage === page) {
            bool = true;
            break;
          }
        }
        if (bool === true) {
          const confirm: boolean = window.confirm(
            this.$t("message.editCommon.beforeUnload") as string
          );
          if (confirm) {
            next();
          }
        } else {
          next();
        }
      }
    });

    this.currentPage = this.$router.currentRoute.name;
    const hacoStorage: Storage = localStorage;
    this.selectedLanguage =
      hacoStorage.getItem("language") &&
      hacoStorage.getItem("language") === "ja"
        ? "ja"
        : "en";
    this.auth();
  }

  reflectCalc(): void {
    const mes: string = this.$t("message.reflection.confirmation") as string;
    const confirmation: boolean = confirm(mes);
    if (confirmation === false) {
      return;
    }
    const url = this.$debugServer + "/api/v1_inner/clear";
    const params: object = this.setAxiosParams(url, "delete");
    this.putDialogText(this.$t("message.reflection.wait") as string, true);

    axios(params)
      .then((): void => {
        this.putDialogText(this.$t("message.reflection.completed") as string);
      })
      .catch((error: any): void => {
        console.log("[Reflection Error]", error);
        this.putDialogText(this.$t("message.editCommon.error.error") as string);
        this.toLoginPage(error);
        Object.keys(error).forEach((k: string) => {
          console.log(k, error[k]);
        });
      });
  }

  changeLanguage(locale: string): void {
    if (this.selectedLanguage === locale) {
      return;
    }
    const hacoStorage: Storage = localStorage;
    this.selectedLanguage = locale;
    hacoStorage.setItem("language", locale);
    document.cookie = "language=" + locale;
    const confirm: boolean = this.confirmLeaving();
    if (confirm === false) {
      return;
    }
    // window.location.reload();
    this.$router.go(0);
  }

  getCurrentToken(): string {
    const hacoStorage: Storage = window.localStorage;
    const token: string = hacoStorage.getItem("accessToken") as string;
    return token;
  }

  async auth(): Promise<boolean> {
    const token: string = this.getCurrentToken();
    if (token) {
      const url = this.$debugServer + "/api/auth/me";
      const params: object = {
        method: "get",
        url: url,
        headers: {
          Authorization: "Bearer " + token
        }
      };

      try {
        await axios(params).then((): void => {
          this.$certification = true;
          this.$forceUpdate();
        });
        return true;
      } catch (error) {
        console.log("[Auth Error]", error);
        Object.keys(error).forEach((k: string) => {
          console.log(k, error[k]);
        });
        return false;
      }
    }
    return false;
  }

  getEditablePageList(): string[] {
    const pages: string[] = [
      "calc",
      "PaperSize",
      "ScenarioEdit",
      "PrinterEdit",
      "CoaterEdit",
      "DiecutEdit",
      "GlueEdit",
      "CustomEdit",
      "Other",
      "Option"
    ];
    return pages;
  }

  confirmLeaving(): boolean {
    console.log(this.$router);
    const pages: string[] = this.getEditablePageList();
    const currentPage: string | undefined = this.$router.currentRoute.name;
    let bool = false;
    for (const page of pages) {
      if (currentPage === page) {
        bool = true;
        break;
      }
    }
    let confirm = true;
    if (bool === true) {
      confirm = window.confirm(
        this.$t("message.editCommon.beforeUnload") as string
      );
    }
    return confirm;
  }

  logout(): void {
    const confirm: boolean = this.confirmLeaving();
    if (confirm === false) {
      return;
    }

    const token: string = this.getCurrentToken();
    const url = this.$debugServer + "/api/auth/logout";
    const params: object = {
      method: "post",
      url: url,
      xsrfHeaderName: "X-CSRF-Token",
      withCredentials: true,
      headers: {
        Authorization: "Bearer " + token
      }
    };
    axios(params)
      .then((): void => {
        const hacoStorage: Storage = window.localStorage;
        hacoStorage.removeItem("accessToken");
        window.location.href = "/";
      })
      .catch((error: any): void => {
        console.log("[Logout Error]", error);
        if (error.response.status === 401) {
          window.location.href = "/";
        }
        Object.keys(error).forEach((k: string) => {
          console.log(k, error[k]);
        });
      });
  }
}
